import { render } from "./Creator.vue?vue&type=template&id=d10b5578"
import script from "./Creator.vue?vue&type=script&lang=js"
export * from "./Creator.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__